import { useEffect, useRef, useState } from "react";

import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

export default function Map({lonLat = []}){
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(0);
  const [lat, setLat] = useState(0);
  const [zoom] = useState(18);
  const url_style = 'https://raw.githack.com/etalab/cadastre.data.gouv.fr/master/components/react-map-gl/styles/vector.json';

  useEffect(() => {
    setLng(lonLat[0]);
    setLat(lonLat[1]);
    if(lonLat.length !== 0) {
      // if (map.current) return; //stops map from intializing more than once
      map.current = new maplibregl.Map({
        container: mapContainer.current,
        style: url_style,
        center: [lng, lat],
        zoom: zoom
      });
  
      map.current.addControl(new maplibregl.NavigationControl(), 'top-right');
  
      new maplibregl.Marker({color: "#FF0000"})
      .setLngLat([lng,lat])
      .addTo(map.current);
    }
    
  }, [lat, lng, lonLat, zoom]);

  return (
    <div className="map-wrap">
      <div ref={mapContainer} className="map" />
    </div>
  );

}